export const TIMER_TO_MANE = 180000; // 3 min in ms
export const TIMER_REPEATE_CODE = 60000; // 1 min in ms

export const TIMER_TO_MODAL = 600000; // 10 min in ms
export const TIMER_TO_LOGOUT = 300000; // 5 min in ms
